import {Question, QuestionTypes} from "../types/Question";

export const formatQuestionData = (data: Partial<Question>) => {
    switch (data.type) {
        case QuestionTypes.QUESTION_TYPE_GROUP:
            return { ...data, options: data.answers?.map(opt => ({ ...opt, value: opt.title.trim() })) };
        case QuestionTypes.QUESTION_TYPE_SINGLE:
            const payload = {
                type: data.type,
                title: data.title,
                value: data.value,
                answers: data.answers
                    ?.filter(option => !isNaN(Number(option.id)) && Number(option.id) > 0) // Chỉ lấy option có id
                    .map((option, index) => ({
                    title: option.title,
                    isCorrect: option.isCorrect,
                    orderNo: index + 1,
                    uid: option.uid,
                    id: option.id
                })),
            }
            return payload;
        case QuestionTypes.QUESTION_TYPE_MULTI:
            return {
                ...data,
                answers: data.answers
                    ?.filter(opt => opt.title && !isNaN(Number(opt.id)) && Number(opt.id) > 0)
                    .map((option, index) => ({
                        title: option.title,
                        isCorrect: option.isCorrect,
                        orderNo: index + 1,
                        uid: option.uid,
                        id: option.id
                    }))
            };
        case QuestionTypes.QUESTION_TYPE_SELECT_OPTION:
            return { ...data, answers: data.answers?.map(opt => ({ id: opt.id, uid: opt.uid, title: opt.title, isCorrect: opt.isCorrect})) };
        case QuestionTypes.QUESTION_TYPE_SHORT_ANSWER:
            return { ...data, value: data.value?.trim()};
        case QuestionTypes.QUESTION_TYPE_DRAG_AND_DROP:
            return { ...data, value: data.value?.trim() };
        case QuestionTypes.QUESTION_TYPE_SPEAK:
            return { ...data, value: data.value?.trim() };
        case QuestionTypes.QUESTION_TYPE_LONG_ANSWER:
            return { ...data, value: data.value?.trim() };
        default:
            return data;
    }
};
